export const CASE_DETAIL_HEADER = [
  {
    value: 'case_id',
    label: 'Case Id',
  },
  {
    value: '',
    label: 'Product',
  },
 
  {
    value: '',
    label: 'Quantity',
  },
  {
    value: '',
    label: 'Received Date',
  },
  {
    value: '',
    label: 'BI Completed Date',
  },
  {
    value: '',
    label: 'Primary Payor',
  },
  {
    value: 'case_status',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'POS',
  },
  {
    value: 'provider.practice_name',
    label: 'Practice Name',
  },
  {
    value: '',
    label: 'Med Ben Coverage',
  },
  {
    value: '',
    label: 'Med Ben PA',
  },
 
];
export const REP_USER_REPORTS = [
  {
    value: "provider_list_field_view",
    label: "Provider List Field View",
  },
  {
    value: "practice_list_field_view",
    label: "Practice List Field View",
  },
  {
    value: "full_report_field",
    label: "Full Report Field",
  },
  {
    value: "med_pa_report_field",
    label: "Med PA Report Field",
  },
]

export const MANUFACTURER_USER_REPORTS = [
  // ...REP_USER_REPORTS,
  {
    value: "provider_list_field_view",
    label: "Provider List Field View",
  },
  {
    value: "provider_list_office_view",
    label: "Provider List Office View",
  },
  {
    value: "practice_list_field_view",
    label: "Practice List Field View",
  },
  {
    value: "practice_list_office_view",
    label: "Practice List Office View",
  },
  {
    value: "full_report_office",
    label: "Full Report Office",
  },
  {
    value: "full_report_field",
    label: "Full Report Field",
  },
  {
    value: "med_pa_report_office",
    label: "Med PA Report Office",
  },
  {
    value: "med_pa_report_field",
    label: "Med PA Report Field",
  },
]


export const REGIONAL_MANAGER_USER_REPORTS = [
 

  {
    value: "provider_list_office_view",
    label: "Provider List Office View",
  },

  {
    value: "practice_list_office_view",
    label: "Practice List Office View",
  },
  {
    value: "full_report_office",
    label: "Full Report Office",
  },
  
  {
    value: "med_pa_report_office",
    label: "Med PA Report Office",
  },
  
]